export default __webpack_public_path__ + "static/media/self_assessment_left.c7e64b67.png";